export default __webpack_public_path__ + "static/part-time-advantage-2-d7840c305f18421c311262dbffa2c0c0.png";